import { Blueprint } from '@/components/builder/base/blueprints/Blueprint';
import { ValidatableBlueprint } from '@/components/builder/base/blueprints/ValidatableBlueprint';
import { HasWidth } from '@/components/builder/base/traits/HasWidth';
import { ValidationErrors } from '@/components/builder/base/types/ValidationErrors';
import { BlueprintDefinition } from '@/components/builder/form/blueprints/BlueprintDefinition';
import { VisibleBlueprint } from '@/components/builder/form/blueprints/VisibleBlueprint';
import { AlwaysChoice } from '@/components/builder/form/enums/AlwaysChoice';
import { HasHelp } from '@/components/builder/form/traits/HasHelp';
import { HasLabel } from '@/components/builder/form/traits/HasLabel';

export const Definition: BlueprintDefinition = {
    type: 'logito-document-preview',
    name: '[[[Podgląd dokumentu]]]',
    icon: 'fa-solid fa-file',
    group: 'logito',
    position: 16,
};

export interface LogitoDocumentListPreviewType extends Blueprint, VisibleBlueprint, HasLabel, HasWidth, HasHelp {
    fieldName: string;
}

export class LogitoDocumentPreviewType implements LogitoDocumentListPreviewType, ValidatableBlueprint
{
    public id: string;
    public type: string;
    public name: string;
    public visible: any;
    public visibleWhen: string;
    public label: Record<string, string>;
    public showLabel: boolean;
    public width: number;
    public minWidth: number;
    public help: Record<string, string>;
    public fieldName: string;
    public errors: ValidationErrors;

    public constructor(id: string, name: string)
    {
        this.id = id;
        this.type = Definition.type;
        this.name = name;
        this.width = 2;
        this.minWidth = 1;
        this.fieldName = null;
        this.visible = AlwaysChoice.Always;
        this.label = { 'pl-PL': 'Podgląd dokumentow' };
        this.help = {};
        this.errors = {};
    }

    public setDefaultWidth(width: number): void
    {
        this.width = Math.min(3, Math.max(this.minWidth, width));
    }

    public validate(): Record<string, ValidationErrors>
    {
        this.errors = {};

        return {
            [this.name]: this.errors,
        };
    }
}
